import { cn } from "@omni/utils/styles";

import { VolumeSkeleton } from "@/components/PaintConfigurator/components/products/components/filters/components/volume/volume.skeleton";
import { FilterButton } from "@/components/PaintConfigurator/components/shared/filter/filterButton";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { useSkeleton } from "@/utils/hooks/useSkeleton.hook";

import { useProductsContext } from "../../../../context/products.context";

type Props = {
    className?: string;
};

const VolumeFilter = ({ className }: Props) => {
    const { t } = useGranite();

    const { volumes, setSelectedVolume, selectedVolume, isLoading } =
        useProductsContext();

    const { showSkeleton, showContent } = useSkeleton(isLoading);

    return (
        <div className={cn("tw:flex tw:flex-col tw:gap-2", className)}>
            <div className={cn("tw:font-bold")}>
                {t("paintConfigurator.volume.label")}
            </div>
            <div className={cn("tw:flex tw:gap-2 tw:flex-wrap")}>
                {showContent &&
                    Array.from(volumes.entries()).map(([volume, _]) => (
                        <FilterButton
                            isSelected={selectedVolume?.volume.value === volume}
                            label={volume}
                            key={volume}
                            onClick={() => setSelectedVolume(volume)}
                        >
                            {volume}
                        </FilterButton>
                    ))}
                {showSkeleton && <VolumeSkeleton />}
            </div>
        </div>
    );
};

export { VolumeFilter };
